export default "__VITE_ASSET__YBzZ1Z0faY$7r7kp5_byMg__"